import classNames from 'classnames';
import { FC } from 'react';

import { CameraIcon } from '@gem/icons';
import { IconView, IconViewSizes } from '@gem/ui-kit';

import styles from './ImageFieldEmpty.styles.m.css';
import { IImageFieldEmptyProps } from './ImageFieldEmpty.types';

export const ImageFieldEmpty: FC<IImageFieldEmptyProps> = ({ type }) => {
  return (
    <div className={classNames(styles.image, styles[type])}>
      <IconView
        Icon={CameraIcon}
        size={IconViewSizes.Big}
        className={styles.cameraIcon}
      />
    </div>
  );
};
